
import { ErrorsTranslationType } from "../../features/errors.types";

export const errors: ErrorsTranslationType = {
  errors: {
    error: "Napaka",
    notFound: "Stran ni najdena",
    deleteAccountError: "Napaka pri brisanju računa. Poskusite znova.",
    loadStoryError: "Napaka pri nalaganju zgodbe. Poskusite znova.",
    loadCharactersError: "Napaka pri nalaganju likov. Poskusite znova.",
    summaryError: "Napaka pri ustvarjanju povzetka. Poskusite znova."
  }
};
